import * as React from "react";

import { connect } from "react-redux";
import { Dispatch } from "redux";
import dispatches from "@stores/dispatches";
import { AppState } from "@stores/type";
import { UsersInFacilityState } from "@stores/domain/mgr/SHUROTEICHAKU/userInFacility/types";
import { RouteComponentProps } from "react-router-dom";
import AdminTemplate from "@components/templates/AdminTemplate";

import { ErrorsState } from "@stores/domain/errors/types";
import RecordBatchPrinting from "@components/organisms/mgr/common/record/RecordBatchPrinting";
import { RecordEachUser } from "@components/organisms/mgr/SHUROTEICHAKU/record/RecordEachUser";

type StateProps = {
  users: UsersInFacilityState["users"];
  errorState: ErrorsState["records"]["data"];
};
type DispatchProps = {
  fetchUsers: () => Promise<void>;
  fetchErrors: () => Promise<void>;
};

type Props = StateProps & RouteComponentProps & DispatchProps;

/**
 * 利用者サマリ
 */
const RecordUsersSummaryCore = (props: Props): JSX.Element => {
  React.useEffect(() => {
    props.fetchUsers();
    props.fetchErrors();
  }, []);

  // 一括印刷のデフォルト項目上書き指定
  const options = [
    { label: "記録を選択", value: "" },
    { label: "支援記録", value: "supportB" },
    { label: "支援レポート", value: "supportReport" }
  ];

  return (
    <AdminTemplate pageName="利用者ごと">
      {/* 記録の一括印刷 */}
      <RecordBatchPrinting history={props.history} options={options} />
      {/* 利用ごとの記録 */}
      <RecordEachUser users={props.users} errorState={props.errorState} />
    </AdminTemplate>
  );
};

const mapStateToProps = (state: AppState): StateProps => ({
  users: state.SHUROTEICHAKU.userInFacility.users,
  errorState: state.errors.records.data
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  const { SHUROTEICHAKU, errorsDispatcher } = dispatches;
  const userInFacilityDispatcher = SHUROTEICHAKU.userInFacilityDispatcher(
    dispatch
  );
  const errorsDispatches = errorsDispatcher(dispatch);
  return {
    fetchUsers: (): Promise<void> => userInFacilityDispatcher.fetch(),
    fetchErrors: (): Promise<void> => errorsDispatches.records()
  };
};

export const RecordUsersSummary = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecordUsersSummaryCore);
